<div style="padding: 0;">
    <div class="panel-group">
        <div class="panel" [class.panel-info]="model.Active" [class.panel-warning1]="!model.Active">
            <!--Live Models-->
            <ng-container *ngIf="live">
                <div class="panel-heading">
                    <h5 style="display: inline-block;">
                        <span class="badge">
                            {{ equipmentCount }}
                        </span>
                        <span [ngClass]="textColor">{{ label }}</span>
                    </h5>
                    <div class="pull-right btn-toolbar" role="toolbar">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-info" title="Show Serial Numbers" (click)="getPoweredBys()">
                                <span data-toggle="tooltip" class="fa fa-lg" [class.fa-chevron-down]="!poweredBysVisible" [class.fa-chevron-up]="poweredBysVisible"></span>
                            </button>
                            <button type="button" class="btn btn-info" title="Model Details" (click)="showDetails()" *ngIf="!listOnly">
                                <span data-toggle="tooltip" class="fa fa-list-alt fa-lg"></span>
                            </button>
                        </div>
                        <ng-container *ngIf="model.Active">
                            <ng-container *ngIf="!live">
                                <div class="btn-group btn-group-sm" *ngIf="!listOnly">
                                    <button type="button" class="btn btn-info" title="Add Equipment" (click)="addEquipment()">
                                        <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                                    </button>
                                    <button type="button" class="btn btn-info" title="Edit Model" (click)="edit()">
                                        <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                                    </button>
                                    <button type="button" class="btn btn-info" title="Remove Model" (click)="delete()">
                                        <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                                    </button>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ng-container>
            <!--End Live Models-->
            <!--Staging Models-->
            <ng-container *ngIf="!live">
                <div [class.panel-heading]="model.Status==0" [class.panel-Staged]="(model.Status==1 || model.Status==2)" [class.panel-warning1]="model.Status==4">
                    <h5 style="display: inline-block;" [style.color]="model.Status==0?'black':'white'">
                        <span class="badge">
                            {{ equipmentCount }}
                        </span>
                        <span>{{ label }}</span>
                    </h5>
                    <div class="pull-right btn-toolbar" role="toolbar">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-info" title="Show Serial Numbers" (click)="getPoweredBys()">
                                <span data-toggle="tooltip" class="fa fa-lg" [class.fa-chevron-down]="!poweredBysVisible" [class.fa-chevron-up]="poweredBysVisible"></span>
                            </button>
                            <button type="button" class="btn btn-info" title="Model Details" (click)="showDetails()" *ngIf="!listOnly">
                                <span data-toggle="tooltip" class="fa fa-list-alt fa-lg"></span>
                            </button>
                        </div>
                        <ng-container *ngIf="!live">
                            <div class="btn-group btn-group-sm" *ngIf="!listOnly">
                                <button type="button" class="btn btn-info" title="Add Equipment" (click)="addEquipment()">
                                    <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                                </button>
                                <button type="button" class="btn btn-info" title="Edit Model" (click)="edit()">
                                    <span data-toggle="tooltip" class="fa fa-edit fa-lg"></span>
                                </button>
                                <button type="button" class="btn btn-info" title="Remove Model" (click)="delete()">
                                    <span data-toggle="tooltip" class="fa fa-trash-o fa-lg"></span>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ng-container>
            <!--End Staging Models-->
            <div class="panel-collapse collapse" [class.in]="poweredBysVisible">
                <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
                    <i class="fa fa-spinner fa-spin"></i> Loading Powered By Data...
                </div>
                <div class="panel-body" *ngIf="poweredBysVisible && !processing">
                    <poweredby-entity [live]="live" [listOnly]="listOnly" [poweredby]="poweredBy" [model]="model" [full]="true" *ngFor="let poweredBy of model.PoweredBys?.Data"></poweredby-entity>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #DeleteModel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Delete Model
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Delete this Model:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="DeleteSelectedModel()">Confirm Delete</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>